// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n0X1z","right":"styles_right__3c1vB"};